import React, { Component } from "react";
import PropTypes from 'prop-types';
import { connect } from "react-redux";
import RequireAuth from "../../layout/HOC/require-auth";
import InputSearch from "../../ui/InputSearch/InputSearch";

import {
    changePhonesSearch,
    startPhonesSearch,
    clearPhonesSearch,
    checkBlockedPhoneAsync,
    checkVerificationPhoneAsync,
    unblockPhoneAsync
  } from "../../../redux/actions/blockedPhones";

import "./BlockedPhones.scss";

const mapStateToProps = state => ({
    ...state.blockedPhones,
    canUnblock: state.blockedPhones.canUnblock,
    isBlocked: state.blockedPhones.isBlocked,
    isVerified: state.blockedPhones.isVerified,
  });

const mapDispatchToProps = dispatch => ({
    changePhonesSearch: value => dispatch(changePhonesSearch(value)),
    startPhonesSearch: (value) => dispatch(startPhonesSearch(value)),
    clearPhonesSearch: () => dispatch(clearPhonesSearch()),
    checkBlockedPhone: (value) => dispatch(checkBlockedPhoneAsync(value)),
    checkVerificationPhone: (value) => dispatch(checkVerificationPhoneAsync(value)),
    unblockPhone: (value) => dispatch(unblockPhoneAsync(value)),
  });

class BlockedPhones extends Component {
    static propTypes = {
        changePhonesSearch: PropTypes.func.isRequired,
        startPhonesSearch: PropTypes.func.isRequired,
        clearPhonesSearch: PropTypes.func.isRequired,
        phoneSearch: PropTypes.string.isRequired,
        activePhoneSearch: PropTypes.string.isRequired,
        unblockPhoneAsync: PropTypes.func.isRequired,
    }

    onChangePhonesSearch = (value) => {
        const { changePhonesSearch, clearPhonesSearch } = this.props;
        (value.length !== 0) ? changePhonesSearch(value) : clearPhonesSearch();
      }

    startPhonesSearching = (value) => {
        const { phoneSearch, startPhonesSearch, checkBlockedPhone, checkVerificationPhone } = this.props;
        //В строке поиска должен быть хотя бы один символ
        if ((value === 'Enter') && (phoneSearch.length !== 0)){
          startPhonesSearch(phoneSearch);
          checkBlockedPhone(phoneSearch);
          checkVerificationPhone(phoneSearch);
        }
      } 
    unblockPhone = () => {
        const { activePhoneSearch, unblockPhone } = this.props;
        unblockPhone(activePhoneSearch);
    }  

    render() {
        const {
            phoneSearch, clearPhonesSearch, canUnblock, isBlocked, isVerified
          } = this.props;
        return (
            <div className="page-wrapper">
            <React.Fragment>
                <div className="page-header" /> 
                <div className="page-content forms blocked-phones">
                <div className="form-header">Разблокировка телефонов</div>
                <InputSearch
                    placeholder="Поиск по номеру телефона"
                    value={phoneSearch}
                    onChange={this.onChangePhonesSearch}
                    onKeyUp={this.startPhonesSearching}
                    onClear={clearPhonesSearch}
                />
                 {(canUnblock &&  (!isBlocked && !isVerified)) ? (
                <React.Fragment>
                <button
                    type="button"
                    className="btn btn-red del-size"
                    onClick={this.unblockPhone}
                  >
                    Разблокировать телефон
                  </button>
                </React.Fragment>
                ): ''}
                </div>
            </React.Fragment>
           
            </div>
    )}
}

export default connect(mapStateToProps, mapDispatchToProps)(RequireAuth(BlockedPhones));